"use strict";

const { effect } = require('@node_modules/@preact/signals-core');

function QFavoriteButton(options) {
    const item = options.item;

    const element = $(/*html*/`
        <span class="btn btn-icon btn-hover-shadow favorite-button btn-circle btn-xs" data-id="favorite_button_${item._uuid}">
            <i class="la la-star${item.isFavorite ? '' : '-o'}"></i>
        </span>
    `).on('click', (event) => {
        event.stopPropagation();
        event.preventDefault();

        item._isFavorite.value = !item._isFavorite.peek();
        item.isFavorite = item._isFavorite.peek();

        if (typeof options.onClick == 'function') options.onClick(event);
    });

    if (item._isFavorite) {
        let firstExecution = true;

        const dispose = effect(() => {
            if (!firstExecution && !document.contains(element.get(0))) {
                dispose();
                return;
            }
            const isFavorite = item._isFavorite.value;

            firstExecution = false;

            element
                .find('i')
                .toggleClass('la-star-o', !isFavorite)
                .toggleClass('la-star', isFavorite)
        });
    }

    return element;
}

// Webpack support
if (typeof module !== 'undefined') {
	module.exports = QFavoriteButton;
}
